import CityPageTemplate from "../city-template/CityPageTemplate";
import { gaithersburgConfig } from "./data";

export default function GaithersburgPage() {
  return <CityPageTemplate config={gaithersburgConfig} />;
}